var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveronLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 28,
    viewBox: "0 0 126 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8711 18.4656C52.4307 21.967 47.55 22.8424 43.9383 20.4433C40.294 18.0441 39.3504 13.0838 41.7908 9.45271C44.3613 5.62709 49.242 4.55722 52.9513 6.98876C54.7735 8.18831 55.9448 10.0363 56.2702 12.1112L43.3526 12.0788C42.7018 12.0788 42.1812 12.5975 42.1812 13.2459C42.1812 13.8943 42.7018 14.4131 43.3526 14.4131H58.8082V14.0564C58.9058 10.4902 57.1813 7.18328 54.1552 5.17321C49.2745 1.93116 43.1248 3.19556 39.8385 8.09105C36.5847 12.9541 37.9187 19.1464 42.9621 22.4858C47.4524 25.4684 53.6672 24.2689 56.8234 19.8273L57.0511 19.5031L55.0663 18.2063L54.8711 18.4656Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3897 14.0935C18.2916 18.3333 14.6922 21.9258 10.3401 21.9258C5.95539 21.9258 2.3887 18.1715 2.3887 13.8023C2.3887 9.17412 5.88995 5.61402 10.3729 5.61402C12.5652 5.61402 14.594 6.52023 16.001 8.04136L5.13734 15.0968C4.58107 15.4529 4.45018 16.1972 4.81012 16.7151C5.17007 17.2653 5.92267 17.3947 6.44622 17.0387L19.4041 8.5592L19.2078 8.23555C17.3099 5.22564 14.005 3.41322 10.3401 3.38086C4.48291 3.41322 0 7.81481 0 13.7052C0 19.5308 4.54835 24.0942 10.6346 24.1266C16.0665 24.1266 20.6148 19.5632 20.7457 14.1259V13.7375H18.357L18.3897 14.0935Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1547 20.8572C28.0202 17.9404 22.7365 3.77781 22.7365 3.77781H20.1758L27.1774 22.5425C27.5339 23.3851 28.2146 23.936 29.3167 23.936C30.4513 23.936 31.132 23.3851 31.4561 22.5425L38.166 4.65285C38.4901 3.87504 37.9067 3 37.0639 3C36.5777 3 36.1239 3.29168 35.9618 3.7454C34.7624 6.727 30.5161 18.3293 29.5437 20.8248C29.4788 21.0517 29.2195 21.0517 29.1547 20.8572Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3586 6.37041V3.57129H61.0938V23.5557H63.3586V13.0427C63.3586 8.55112 66.206 5.78454 68.8268 5.78454H69.7004C70.3151 5.78454 70.8005 5.29633 70.8005 4.67792C70.8005 4.05951 70.3151 3.57129 69.7004 3.57129H68.665C66.4324 3.57129 64.4587 4.84066 63.3586 6.37041Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.443 13.5632C101.443 19.3971 96.7135 24.1264 90.8796 24.1264C85.0457 24.1264 80.3164 19.3971 80.3164 13.5632C80.3164 7.7293 85.0457 3 90.8796 3C96.7135 3 101.443 7.7293 101.443 13.5632ZM90.8796 20.0185C94.4447 20.0185 97.3349 17.1283 97.3349 13.5632C97.3349 9.99803 94.4447 7.1079 90.8796 7.1079C87.3144 7.1079 84.4243 9.99803 84.4243 13.5632C84.4243 17.1283 87.3144 20.0185 90.8796 20.0185Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.527 5.55326C117.869 3.87263 115.561 3 112.862 3C110.164 3 107.856 3.87263 106.197 5.55326C104.604 7.16925 103.727 9.46396 103.727 12.0172V23.5554H108.376V12.0172C108.376 9.43164 110.294 7.46013 112.862 7.46013C115.431 7.46013 117.349 9.43164 117.349 12.0172V23.5554H121.998V12.0172C121.998 9.46396 121.12 7.16925 119.527 5.55326Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11862_133120)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.364 3C75.5301 3 70.8008 7.7293 70.8008 13.5632C70.8008 19.3971 75.5301 24.1264 81.364 24.1264H90.8802H90.8803C96.7142 24.1264 101.444 19.3971 101.444 13.5632C101.444 7.7293 96.7142 3 90.8804 3H90.8802H81.364ZM90.8802 3C96.7141 3 101.443 7.7293 101.443 13.5632C101.443 19.3971 96.7141 24.1264 90.8802 24.1264C85.0463 24.1264 80.317 19.3971 80.317 13.5632C80.317 7.7293 85.0463 3 90.8802 3Z",
    fill: "#EDFAFF",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11862_133120",
    x: 70.8008,
    y: 3,
    width: 30.6445,
    height: 23.1265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301146 0 0 0 0 0.400217 0 0 0 0 0.491667 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11862_133120"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveronLogoWhite);
export default __webpack_public_path__ + "static/media/everon-logo-white.4964dce640771a09023a089c9edd4040.svg";
export { ForwardRef as ReactComponent };